import { createContext, useContext, ReactNode } from "react";
import { DetailDataResponse, OptionsResponse, Tab } from "@/types/dynamic-detail";

interface DynamicDetailContextType {
    detailData: DetailDataResponse | null;
    tabs: Tab[];
    loading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
    metadata: OptionsResponse;
}

const DynamicDetailContext = createContext<DynamicDetailContextType | undefined>(undefined);

interface DynamicDetailProviderProps {
    children: ReactNode;
    detailData: DetailDataResponse | null;
    tabs: Tab[];
    loading: boolean;
    error: string | null;
    refetch: () => Promise<void>;
    metadata: OptionsResponse;
}

export function DynamicDetailProvider({ children, detailData, tabs, loading, error, refetch, metadata }: DynamicDetailProviderProps) {
    return <DynamicDetailContext.Provider value={{ detailData, tabs, loading, error, refetch, metadata }}>{children}</DynamicDetailContext.Provider>;
}

export function useDynamicDetailContext() {
    const context = useContext(DynamicDetailContext);
    if (context === undefined) {
        throw new Error("useDynamicDetailContext must be used within a DynamicDetailProvider");
    }
    return context;
}
